import { useQueryData, useLocalizedJson } from 'spectacle-ui-game-bridge-react';
import config from '../config';

export type PreloginContent = {
  agree: string; // "I Agree"
  applicationOutOfDate: string; // "Application asset version is outdated, please update the application from App Store"
  cdniTitle: string; // "CDNI"
  cellularNetworkDownloadTip: string; // "Need to download &&1 files, you are currently on a mobile cellular data network, continue to download may incur data costs. Do you still want to download?"
  close: string; // "Close"
  codeOfConductAcceptance: string; // "I acknowledge having read the:"
  codeOfConductAgreementUrl: string; // "https:// www.callofduty.com/values"
  codeOfConductAgreementVersion: string; // "1"
  codeOfConductCta: string; // "Call of Duty Code of Conduct"
  downloading: string; // "Downloading"
  downloadOverData: string; // "Download over data"
  downloadTimedOut: string; // "Your connection to our server timed out. Please check your internet connection and try again."
  error: string; // "Error",
  errorGeneric: string; // "Sorry, something went wrong. Please try again."
  failedToConnectToCDN: string; // "Failed to connect to CDN server, please check your internet connection"
  failedToGetUpdate: string; // "We can't connect you to our server right now, but we'll have things back to normal soon! Please try again later."
  gameBridgeError: string; // "We're sorry but an error has occured. Click the button below to proceed."
  gameBridgeErrorCta: string; // "Proceed"
  guestSignInCta: string; // "Play as Guest"
  guestSignInContinue: string; // "Continue as Guest"
  loginAccountTitle: string; // "Call of Duty Account"
  loginBuild: string; // "Build",
  loginNotice: string; // "NOTICE: iPhone 8+, iPhone X, iPhone XR and iPhone SE (2nd Gen) are not currently supported, but will be in future releases. We appreciate your patience at this time. Stay tuned for updates",
  loginTip: string; // "Sign in or Register for a Call of Duty account to enjoy cross-progression benefits and more!"
  loginCrossProgression: string; // "Enjoy cross-progression benefits and more with a Call of Duty account!"
  logoAlt: string; // "Call of Duty: Warzone Mobile",
  privacyPolicyAcceptance: string; // "I acknowledge having read the:"
  privacyPolicyAgreementUrl: string; // "https:// www.activision.com/legal/privacy-policy"
  privacyPolicyAgreementVersion: string; // "1"
  privacyPolicyCta: string; // "Activision Privacy Policy"
  registerCta: string; // "Sign Up"
  reviewTerms: string; // "Review Terms"
  serviceAcceptance: string; // "I acknowledge and agree to the:"
  serviceAgreementUrl: string; // "https:// www.callofduty.com/hub/wzm-eula"
  serviceAgreementVersion: string; // "1",
  serviceCta: string; // "Software License and Service Agreement"
  koTermsTitle1: string; // Review Terms 1/2 // 2.8+
  koTermsTitle2: string; //Review Terms 2/2 // 2.8+
  koTermsPIICollectionAcceptance: string; // I acknowledge and agree to the: // 2.8+
  koTermsPIICollectionUrl: string; // 2.8+
  koTermsPIICollectionVersion: string; // 1 // 2.8+
  koTermsPIICollectionCta: string; // Software License and Service Agreement // 2.8+
  koTermsDesc2: string; // Call of Duty Warzone Mobile will ask for the following permissions based on certain features requirements: // 2.8+
  koTermsMicrophonePermission: string; // Microphone Permission // 2.8+
  koTermsMicrophonePermissionDesc: string; // Used for voice chat // 2.8+
  koTermsCameraPermission: string; // Camera Permission // 2.8+
  koTermsCameraPermissionDesc: string; // Used for QR code scan // 2.8+
  koTermsOptional: string; // (*optional) // 2.8+
  koTermsOptionalDesc: string; // *Optional permissions are required only when you use such a feature, and you may use the other features of the game even if you do not give permission. // 2.8+
  signInCta: string; // "Login"
  signInEmailError: string; // "Please enter a valid email address."
  signInEmailLabel: string; // "Email"
  signInEmailPlaceholder: string; // "Enter your email"
  signInError: string; // "We're sorry those credentials are incorrect please try again."
  signInForgotPasswordLink: string; // "Forgot Password?"
  signInLoginCta: string; // "Login"
  signInPasswordError: string; // "Please enter a password."
  signInPasswordLabel: string; // "Password"
  signInPasswordPlaceholder: string; // "Enter Password"
  signInSignUpCta: string; // "Sign Up"
  signInSignUpTitle: string; // "Don't Have a Call of Duty account?"
  Status: boolean; // false,
  StatusUrl: string; // "https:// prod.cdni.callofduty.com/prelogin/web/index.html#/status"
  termsOfUseAcceptance: string; // "I acknowledge and agree to the:"
  termsOfUseAgreementUrl: string; // "https:// www.activision.com/legal/terms-of-use"
  termsOfUseAgreementVersion: string; // "1"
  termsOfUseCta: string; // "Terms of Use"
  timeRemaining: string; // "Estimated remaining time: &&1 minutes"
  unexpectedError: string; // "Unexpected error, error code:"
  upsellTitle: string; // "Use a COD Account for these Extra Perks!", // DEPRECATED as of 2.8.0
  upsellTitle1: string; // "CROSS-PROGRESSION"
  upsellTitle2: string; // "IS HERE"
  upsellPanel1Description: string; // "Level up in Modern Warfare II and Warzone 2.0 when you level up in Warzone Mobile" // DEPRECATED as of 2.8.0
  upsellPanel1Title: string; // "Shared Player Level",
  upsellPanel2Description: string; // "Weapon unlocks are shared across titles" // DEPRECATED as of 2.8.0
  upsellPanel2Title: string; // "Shared weapon progression",
  upsellPanel3Description: string; // "Battle pass and Bundle Content are shared across titles" // DEPRECATED as of 2.8.0
  upsellPanel3Title: string; // "Shared Content"
  upsellPanelDescription: string; // "Connect your COD account to level up anywhere and unlock epic in-game rewards with friends across all platforms!"
  upsellPanelCta: string; // "Got It"
  under1min: string; // "Under 1 minute remaining"
  usingDev: string; // "Using Dev CDN"
  webBasedLogin: boolean; // true
  guestLoginCTA: string; // "Create"
  guestLoginHeader: string; // "Choose your username"
  guestLoginDesc: string; // "This will also be your Activision ID."
  guestLoginCharacterLimit: string; // "character limit 16"
  cdniProgress: Record<string, string>;
  usernameRequiredLength: string; // "Must contain &&1-&&2 characters"
  usernameReqSingleGlyphLimit: string; // "Contains invalid glyph"
  usernamePleaseComplete: string; // "Please complete section"
  ok: string; // "Ok"
  accountLogin: string; // "Account Login"
  notice: string; // "Notice"
  gotToAppStore: string; // "Go To The Store"
  restartRequest: string; // "The update is complete, the game needs to be restarted"
  retry: string; // "Retry"
  deviceStorageFull: string; // "DEVICE STORAGE FULL!"
  insuffcientDiskSpaceIos: string; // We're sorry, there is currently not enough space to install this app on your device. The size of this install is &&2 MB. Please free up space by deleting apps or media files you no longer need and try again. To do this, go to Settings > General > [Device] Storage.
  insuffcientDiskSpaceAndroid: string; // We're sorry, there is currently not enough space to install this app on your device. The size of this install is X MB. Please free up space by deleting apps or media files you no longer need and try again.
  proceedAnyway: string; // "Proceed Anyway"
  cellularNetworkDownload: string; // "Download over data"
  exitGame: string; // "Exit Game"
  enterTheSecurityCode: string; // "Enter the security code"
  newLocation: string; // "This appears to be a new device, or location. Please enter the security code from your authenticator app to continue."
  continue: string; // "Continue"
  tooManyAttempts: string; // "Too many attempts have been made. Please wait &&1 before trying again."
  fewMinutes: string; // "a few minutes"
  showDeveloperOverlay: boolean; // false
  checkingForUpdates: string; // "Checking for updates..."
  enableGuestLogin: boolean; // true
  loading: string; // "Loading..."
  newUpdateAvailable: string; // "New Update Available"
  update: string; // "Update"
  accountUpgraded: string; // "Account Upgraded"
  accountUpgradedDescription: string; //  "You have upgraded from a guest account to a Call of Duty account. Please log in with your Call of Duty account."
  login: string; // "Log In"
  inappropriateText: string; // "This text is inappropriate"
  guestLoginPlaceholder: string; // "Enter Name"
  offlineHeading: string; // You are offline
  offlineDesc: string; // You are offline. Please check your internet connection and try again.
  urlRegister: string; // https://profile.callofduty.com/wzm/registerMobileGame
  urlForgotPassword: string; // https://profile.callofduty.com/cod/forgotPassword#forgot-password
  enablePostLoginMessages: boolean; // false,
  postLoginStatus: string; // Entering base, please wait...
  postLoginMessage: string; // Verifying identity
  errorMultipleLogins: string; // The Call of Duty: Warzone Mobile server is not available due to multiple logins of your Activision Account. Please log out of your other devices and sessions and try again.
  statusMessage: string; // Servers are currently offline for maintenance. Please check back in again later.
  statusErrorMessage: string; // An unexpected error has occurred, please try again later.
  statusCheckStatus: string; // Checking Server Status...
  statusPageTitle: string; // Server Status
  statusCta: string; // Check Status
  goToSettings: string; // Go To Settings
  goToStorage: string; // Go to Storage
  cdniPhaseMessages: Record<string, string>;
  cdniNumberOfFills: number; // 3
  cdniMinimumBytesPerFill: number; // 0
  softPromptHeading: string; // Never Miss a Drop!
  softPromptDesc: string; // Don't miss a single party invite or message with notifications on.
  softPromptCancel: string; // Not Now
  softPromptAccept: string; // Accept
  softPromptInterval: number; // <Timestamp>
  enableSoftPromptNotifications: boolean; // true
  guestLoginFailed: string; // These credentials are invalid. Please try again.
  enableReminderNotification: boolean; // true
  reminderNotificationName: string; // Reminder Notification
  reminderNotificationDelay: number | string; // 30
  reminderNotificationTitle: string; // Test Title
  reminderNotificationBody: string; // Test Body
  tellUsYourAge: string; // Tell Us Your Age
  selectAge: string; // Select Age
  unableToProceedHeading: string; // Unable to Proceed
  unableToProceedDesc: string; // Sorry, you cannot access the game at this time due to regional regulations.
  enableLoginBigPlay: boolean; // false
  enableUKAcceptance: boolean; // false
  enableKOAcceptance: boolean; // false
};

export default function useContentForBuild(): [PreloginContent | null, boolean, Error | null, () => void, number] {
  const [content, loading, error, retry, retryCount] = useLocalizedJson<PreloginContent>(config.acceptanceUrl);
  const [build] = useQueryData<string>('game', 'build_number');

  return [
    // Always fall back to default if we cannot find the build number
    content?.builds[build ?? 'default'] ?? content?.builds.default ?? null,
    loading,
    error,
    retry,
    retryCount,
  ];
}
